import { useCallback, useState } from "react";
import {
  deleteOrderRequest,
  downloadOrdersCsv,
  uploadOrdersCsv,
} from "../api/ordersApi";

export const useOrdersActions = ({ authToken, authScheme, onOrderDeleted }) => {
  const [message, setMessage] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [csvMessage, setCsvMessage] = useState("");

  const handleDownload = useCallback(async () => {
    setDownloading(true);
    setMessage(null);
    try {
      await downloadOrdersCsv(authToken);
      setMessage({ kind: "success", text: "CSV file downloaded." });
    } catch (error) {
      setMessage({ kind: "error", text: error.message });
    } finally {
      setDownloading(false);
      setTimeout(() => setMessage(null), 3000);
    }
  }, [authToken]);

  const handleCsvUpload = useCallback(
    async (file) => {
      if (!file) {
        setCsvMessage("Select a CSV file.");
        return;
      }
      setCsvMessage("");
      try {
        const data = await uploadOrdersCsv({ file, authToken, authScheme });
        setCsvMessage(`OK: created ${data?.created ?? 0}, updated ${data?.updated ?? 0}.`);
        onOrderDeleted?.();
      } catch (error) {
        setCsvMessage(`Import error: ${error.message}`);
      } finally {
        setTimeout(() => setCsvMessage(""), 5000);
      }
    },
    [authScheme, authToken, onOrderDeleted],
  );

  const removeOrder = useCallback(
    async (id) => {
      if (!window.confirm("Are you sure you want to delete this order?")) return;
      setDeleteLoading(true);
      setMessage(null);
      try {
        await deleteOrderRequest(id, authToken);
        setMessage({ kind: "success", text: "Order deleted." });
        onOrderDeleted?.();
      } catch (error) {
        setMessage({ kind: "error", text: error.message || "Failed to delete the order." });
      } finally {
        setDeleteLoading(false);
        setTimeout(() => setMessage(null), 3000);
      }
    },
    [authToken, onOrderDeleted],
  );

  return {
    csvMessage,
    deleteLoading,
    downloading,
    handleCsvUpload,
    handleDownload,
    message,
    removeOrder,
    setCsvMessage,
    setMessage,
  };
};
